<script>
  // add icons as such  <CustomIcon name="trash" />
  export let name = "";
  export let label = "";
  export let width = "24";
  export let height = "24";
  export let color = "white";
  export let disabled = false;
  import svgs from "../assets/svgs";

  const displayIcon = svgs[name] || svgs["dflt"];
  export let viewBox = `0 0 ${displayIcon?.box || 24} ${
    displayIcon?.box || 24
  }`;
</script>

<span
  title={label || name}
  class={`${disabled ? "cursor-default" : "cursor-pointer"} content-center`}
>
  <svg class={$$props.class} fill="none" {width} {height} {disabled} {viewBox}>
    {@html displayIcon.svg.replaceAll("fillcolor", !disabled ? color : "gray")}
  </svg>
</span>
